export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7292.32306e35.jpg";